import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchRecentlyViewedProducts as fetchRecentlyViewedProductsService } from "./recently-viewed.service";
import { RecentlyViewedResponse, GetRecentlyViewedRequest } from "./recently-viewed.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getRecentlyViewedProducts = createAsyncThunk<
  RecentlyViewedResponse,
  GetRecentlyViewedRequest | undefined,
  { rejectValue: string }
>("recentlyViewed/getRecentlyViewedProducts", async (params, { rejectWithValue }) => {
  try {
    const response = await fetchRecentlyViewedProductsService(params);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});